import { Pressable, View } from 'react-native'
import { OptionBadgeProps } from './types'
import OptionBadge from './OptionBadge'

interface Props {
  options: OptionBadgeProps[]
  onPress?: () => void
}

export default function Options({ options, onPress }: Props) {
  return (
    <Pressable
      onPress={onPress}
      disabled={!onPress}
      className="bg-neutral-0 flex h-12 flex-row items-center justify-center gap-2 rounded-lg border border-black/10 px-2"
    >
      {options.map((option, index) => (
        <OptionBadge key={index} {...option} />
      ))}
    </Pressable>
  )
}
